import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { IntentBehaviorProvider } from 'seagull';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
export default function SeagullIntentBehaviorProvider(props) {
    const { getIntentBehavior, children } = props;
    const userRole = useStore(selectors.user.role);
    const isViewMode = useStore(selectors.isViewMode);
    const { t: acTexts } = useLocaleKeys('components.accessControl');
    const intentBehavior = useMemo(()=>getIntentBehavior(userRole, {
            isViewMode,
            tooltips: acTexts
        }), [
        userRole,
        isViewMode,
        getIntentBehavior
    ]);
    return /*#__PURE__*/ _jsx(IntentBehaviorProvider, {
        value: intentBehavior,
        children: children
    });
}
